/* RESPONSIBLE TEAM: team-proactive-support */
import Route from '@ember/routing/route';

export default class OutboundGuideRoute extends Route {
  redirect() {
    return this.replaceWith('apps.app.outbound.index');
  }
}
